import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(others)/installation-guide/page.tsx");
